import { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";

/**
 * The shop scope lives in the global header, but only workspace-scoped pages own it:
 * resource pages (a campaign, a managed group) follow their own Shop, and an ambient
 * scope there would be misleading. Pages opt in by rendering `HeaderScopePortal`.
 */
const HeaderScopeContext = createContext<{
  target: HTMLElement | null;
  setTarget: (element: HTMLElement | null) => void;
} | null>(null);

export function HeaderScopeProvider({ children }: { children: React.ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  return (
    <HeaderScopeContext.Provider value={{ target, setTarget }}>
      {children}
    </HeaderScopeContext.Provider>
  );
}

export function HeaderScopeSlot({ className }: { className?: string }) {
  const context = useContext(HeaderScopeContext);
  return <div ref={context?.setTarget} data-slot="header-scope" className={className} />;
}

export function HeaderScopePortal({ children }: { children: React.ReactNode }) {
  const context = useContext(HeaderScopeContext);
  if (!context) return <>{children}</>;
  return context.target ? createPortal(children, context.target) : null;
}
